/**
 * TODO: Properly remove @transfeeradev/api-clients dependency by not using dependencies that use it.
 *
 * This non-sense below is a temporary solution to avoid runtime errors while being able
 * to remove server-side HTTP client packages from the browser bundle.
 *
 * This because @transfeeradev/transfer-validation pulls in @transfeeradev/api-clients which
 * depends on the Node.js built-in `http` module — unavailable in the browser.
 *
 * Any unexpected call to these client methods will throw a TypeError,
 * since the stub classes do not implement any methods.
 * The constructor call is captured by Sentry to signal unexpected instantiation.
 */
import * as Sentry from '@sentry/browser';

const logSentry = logMessage => {
  Sentry.captureException(new Error(`[WEBAPP API-CLIENTS] - ${logMessage}`), {
    level: Sentry.Severity.Info,
    fingerprint: ['WEBAPP API-CLIENTS']
  });
};

class StubClient {
  constructor(name) {
    logSentry(`${name}.constructor`);
  }
}

const makeStubClient = name =>
  class extends StubClient {
    constructor() {
      super(name);
    }
  };

export class HttpError extends Error {}
export class Response {}

export const CelcoinIntegrationsClient = makeStubClient('CelcoinIntegrationsClient');
export const AbcBrasilIntegrationsClient = makeStubClient('AbcBrasilIntegrationsClient');
export const BtgIntegrationsClient = makeStubClient('BtgIntegrationsClient');
export const DictIntegrationsClient = makeStubClient('DictIntegrationsClient');
export const StatementClient = makeStubClient('StatementClient');
export const TransfeeraAdminClient = makeStubClient('TransfeeraAdminClient');
export const TransfeeraClient = makeStubClient('TransfeeraClient');
export const ConciliationClient = makeStubClient('ConciliationClient');
export const BillingClient = makeStubClient('BillingClient');
export const BoletoClient = makeStubClient('BoletoClient');
export const CpfCnpjClient = makeStubClient('CpfCnpjClient');
export const AccountsClient = makeStubClient('AccountsClient');
export const AccountsAdminClient = makeStubClient('AccountsAdminClient');
export const CompanyClient = makeStubClient('CompanyClient');
export const WebHookClient = makeStubClient('WebHookClient');
export const WebHookLegacyClient = makeStubClient('WebHookLegacyClient');
export const DailyControlClient = makeStubClient('DailyControlClient');
export const LoginClient = makeStubClient('LoginClient');
export const ContaCertaClient = makeStubClient('ContaCertaClient');
export const AutomationClient = makeStubClient('AutomationClient');
export const BankStatementClient = makeStubClient('BankStatementClient');
export const BradescoBatchFilesIntegrationsClient = makeStubClient('BradescoBatchFilesIntegrationsClient');
export const TransfeeraInternalClient = makeStubClient('TransfeeraInternalClient');
export const TransfeeraAdminInternalClient = makeStubClient('TransfeeraAdminInternalClient');
export const BilletClient = makeStubClient('BilletClient');
export const PdfGeneratorClient = makeStubClient('PdfGeneratorClient');
export const ReportClient = makeStubClient('ReportClient');
export const AuditClient = makeStubClient('AuditClient');
export const InfractionClient = makeStubClient('InfractionClient');
export const PixPayinEngineClient = makeStubClient('PixPayinEngineClient');
export const PayoutEngineClient = makeStubClient('PayoutEngineClient');
export const PixPayoutEngineClient = makeStubClient('PixPayoutEngineClient');
export const IntegrationProxyClient = makeStubClient('IntegrationProxyClient');
export const CheckpointClient = makeStubClient('CheckpointClient');
export const CUCInternalClient = makeStubClient('CUCInternalClient');
export const JdnpcClient = makeStubClient('JdnpcClient');
export const JdpiClient = makeStubClient('JdpiClient');
export const LedgerClient = makeStubClient('LedgerClient');
export const CardPayinClient = makeStubClient('CardPayinClient');

export const external = {
  RDStationClient: makeStubClient('RDStationClient')
};

export default {
  HttpError,
  Response,
  CelcoinIntegrationsClient,
  AbcBrasilIntegrationsClient,
  BtgIntegrationsClient,
  DictIntegrationsClient,
  StatementClient,
  TransfeeraAdminClient,
  TransfeeraClient,
  ConciliationClient,
  BillingClient,
  BoletoClient,
  CpfCnpjClient,
  AccountsClient,
  AccountsAdminClient,
  CompanyClient,
  WebHookClient,
  WebHookLegacyClient,
  DailyControlClient,
  LoginClient,
  ContaCertaClient,
  AutomationClient,
  BankStatementClient,
  BradescoBatchFilesIntegrationsClient,
  TransfeeraInternalClient,
  TransfeeraAdminInternalClient,
  BilletClient,
  PdfGeneratorClient,
  ReportClient,
  AuditClient,
  InfractionClient,
  PixPayinEngineClient,
  PayoutEngineClient,
  PixPayoutEngineClient,
  IntegrationProxyClient,
  CheckpointClient,
  CUCInternalClient,
  JdnpcClient,
  JdpiClient,
  LedgerClient,
  CardPayinClient,
  external
};
